import React, { useState } from 'react';
import Logo from "../Img/logo.png";
import CustomNavLink from "../_Components/CustomNavLink";
import { Link } from 'react-router-dom';

const AdminTemplate = (props) => {

    const usuario = JSON.parse(localStorage.getItem("user"))

    const removeToggled = (e) => {
        window.localStorage.setItem("rotaAtual", e.target.name);
        // setTimeout(reload, 100)
    }

    const logout = () => {
        window.localStorage.removeItem('user')
        window.localStorage.removeItem("rotaAtual");
        window.location.href = '/'
    }

    const [expanded, setExpanded] = useState(false);
    const scrollarPage = () => {
        setExpanded(!expanded)
        if (!expanded)
            window.scrollTo(500, 0);
        else {
            window.scrollTo(0, 0);
        }
    }

    return (
        <div className="wrapper">

            <div className="sidebar">
                <div className="sidebar-wrapper">
                    <div className="logo">
                        <img src={Logo} style={{ width: '10em', height: '4em' }} />
                        <div className="text-center small mt-2">
                            <div style={{ fontWeight: '500' }}>{usuario.nome.toUpperCase()} • Administrativo</div>
                        </div>
                    </div>
                    <ul className="nav">
                        <CustomNavLink onClick={logout} className="nav-link" >
                            <i class="fas fa-sign-out-alt"></i>
                            <span>SAIR</span>
                        </CustomNavLink>
                        <CustomNavLink to="/admin-gerenciar-gerentes" onClick={removeToggled.bind(this)} className="nav-link">
                            <i className="far fa-user-circle" />
                            <span>Gerentes</span>
                        </CustomNavLink>
                        <CustomNavLink to="/admin-relatorios" name="admin-relatorios" onClick={removeToggled.bind(this)} className="nav-link">
                            <i class="fas fa-book-open"></i>
                            <span>Relatórios</span>
                        </CustomNavLink>
                    </ul>
                </div>
            </div>
            <div className="main-panel">
                <nav className="navbar navbar-expand-lg " color-on-scroll="500">
                    <div className="container-fluid">
                        <Link className="navbar-brand" to="#">
                            {props.label}
                        </Link>
                        <button
                            id="sideButton"
                            href="#"
                            className="navbar-toggler navbar-toggler-right"
                            type="button"
                            data-toggle="collapse"
                            aria-controls="navigation-index"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                            onClick={scrollarPage}
                        >
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                            <span className="navbar-toggler-bar burger-lines" />
                        </button>
                        <div
                            className="collapse navbar-collapse justify-content-end"
                            id="navigation"
                        >
                            {/* <ul className="navbar-nav ml-auto">
                                <li className="nav-item">
                                    <CustomNavLink className="nav-link" name="logout" onClick={removeToggled.bind(this)}>
                                        <span className="no-icon">Sair</span>
                                    </CustomNavLink>
                                </li>
                            </ul> */}
                        </div>
                    </div>
                </nav>
                <div className="content">
                    {props.children}
                </div>
                <footer className="footer">
                    <div className="container-fluid">
                        <nav>
                            <ul className="footer-menu">
                                <li>
                                    <Link to="#">Empresa</Link>
                                </li>
                                <li>
                                    <Link to="#">Regulamento</Link>
                                </li>
                                <li>
                                    <Link to="#">Outros projetos</Link>
                                </li>
                            </ul>
                            <p className="copyright text-center">
                                Proprietário ©
                                <Link to="https://www.instagram.com/sorteflash/">SorteFlash</Link>
                            </p>
                        </nav>
                    </div>
                </footer>
            </div>
        </div>
    );
};

export default AdminTemplate;